import { AppImages } from "../constants/imageConstants";
import {
  Box,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
const LoadingText = () => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDots((previousDots) =>
        previousDots === "....." ? "" : previousDots + "."
      );
    }, 500);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Stack
      direction="row"
      spacing={0.5}
      sx={{ mt: 1 }}
      justifyContent="center"
      alignItems="center"
    >
      <Typography
        sx={{
          color: "#fff",
          textShadow: "0 0 1px rgba(255, 255, 255,0.9)",
        }}
      >
        Loading
      </Typography>
      <Typography
        sx={{
          color: "#fff",
          letterSpacing: "2px",
          textShadow: "0 0 1px rgba(255, 255, 255,0.9)",
        }}
      >
        {dots}
      </Typography>
    </Stack>
  );
};

const PageLoader = ({ value }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: value ? 0 : 999999,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: theme.custom.gradient,
        cursor: "none",
        userSelect: "none",
      }}
    >
      {/* Image + CircularProgress Wrapper */}
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          size={80}
          thickness={2}
          sx={{
            color: theme.palette.common.white,
            opacity: 0.8,
          }}
        />
        <Box
          component="img"
          src={AppImages.trilliant}
          alt="Logo"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: 50,
            height: 50,
            transform: "translate(-50%, -50%)",
            borderRadius: "50%",
            backgroundColor: theme.palette.common.white,
            objectFit: "contain",
            padding: "4px",
            boxShadow: "0 0 20px 2px rgba(255,255,255,0.8)",
          }}
        />
      </Box>

      <LoadingText />
    </Box>
  );
};

export default PageLoader;
